module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "nav-user",
    attrs: {
      "src": require("../../assets/app.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "nav-user",
    attrs: {
      "src": require("../../assets/device.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "nav-user",
    attrs: {
      "src": require("../../assets/play.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "nav-user",
    attrs: {
      "src": require("../../assets/sys.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "nav-user",
    attrs: {
      "src": require("../../assets/images/banner.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "nav-user",
    attrs: {
      "src": require("../../assets/images/notice.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "nav-user",
    attrs: {
      "src": require("../../assets/images/specialOffer.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "nav-user",
    attrs: {
      "src": require("../../assets/images/goodsGroup.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-735d508e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/png.vue
// module id = 1079
// module chunks = 2